var path = '/var/www/mmscny-cms/src/app/common/components/modal/modal.html';
var html = "<div ng-if=$ctrl.resolve.details.title class=modal-header> {{$ctrl.resolve.details.title}} </div> <div class=modal-body> <p>{{$ctrl.resolve.details.bodyMessage}}</p> </div> <div class=modal-footer> <button ng-repeat=\"button in $ctrl.resolve.buttons\" ng-click=$ctrl.buttonClick(button) class=btn ng-class=\"{'cancel-btn': !button.isPrimary, 'submit-btn': button.isPrimary === true}\">{{button.name}}</button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/modal/modal.html
// module id = 730
// module chunks = 0